export enum UserProfileMode {
  TENANT = 'TENANT',
  CORE = 'CORE',
}
